import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/app/provide/common.service';
import { PaymentService } from '../../../provide/payment.service';
declare var $;
@Component({
    selector: 'app-customer-order-overview',
    templateUrl: './customer-order-overview.component.html',
    styleUrls: ['./customer-order-overview.component.scss'],
    standalone: false
})
export class CustomerOrderOverviewComponent implements OnInit {
  _id: any;
  qtyA: any;
  serviceData: any;
  headingName: any = 'Order Review';
  linkerRouteItems: any = [
    { name: 'Home', route: '/home' },
    { name: 'Cart', route: '/addtoCart-customer' },
    { name: 'Address', route: '/list-address-customer' },
    { name: 'Order', route: '/order-overview-customer' },
  ];
  flag: boolean = true;
  idOfAddress: any;
  cryptoBalance : any
  availableTokenToUse : number = 0
  isCoinRedeem : boolean = false
  selectedPaymentMethod: string = '';
  constructor(
    private activatedroute: ActivatedRoute,
    public commonService: CommonService,
    private router: Router,
    public sanatizer: DomSanitizer,
    private paymentService: PaymentService
  ) {
    this.activatedroute.queryParams.subscribe((res: any) => {
      this._id = res._id;
      this.idOfAddress = res.idOfAddress;
    });
  }

  address: any;

  ngOnInit(): void {
    // this.getSimiliarProduct();
    this.commonService.cryptoBalance.subscribe((ele)=>{
      this.cryptoBalance = ele

    })
    this.getuserCartList();
    this.getProfile();
    
    // Initialize with no payment method selected
    this.selectedPaymentMethod = '';
    
    // Listen for modal open event to reset selection
    $(document).on('shown.bs.modal', '#premiumPaymentModal', () => {
      // Reset selection when modal opens - user must select a payment method
      this.selectedPaymentMethod = '';
    });
  }
  getSimiliarProduct() {
    let apiReqUrl: any = `product/productMightLike`;
    this.commonService.showSpinner();
    this.commonService.postApi(apiReqUrl, {}, 0).subscribe((res: any) => {
      if (res.responseCode == 200) {
        this.serviceData = res.result.docs;
        this.commonService.hideSpinner();
      } else {
        this.commonService.hideSpinner();
        this.commonService.errorToast(res.responseMessage);
      }
    });
  }
  getPrice(e: any) {
    if (typeof e != 'string') {
      e = String(e);
    }
    return this.commonService.getPrice(e)
  }
  cartListDetails: any = new Array(1);
  cartId: any;
  getID: any = [];
  payOutDetail: any;
  dropDownData: any = [];
  isLoading: boolean = true;
  isProfileLoading: boolean = true;
  
  getuserCartList(showDeleteSuccessToast?: boolean) {
    let apiReqUrl = `user/cartList`;
    this.isLoading = true;
    this.commonService.showSpinner();
    this.commonService.getApi(apiReqUrl, 1).subscribe(
      (res: any) => {
        if (res.responseCode == 200) {
          this.cartListDetails = res.result.cartList;
          this.payOutDetail = res.result.payOutAmount;
          this.isLoading = false;

          let grandTotal = this.payOutDetail ? this.payOutDetail.totalAmountWithVat : 0
          let availableToken = Number(this.cryptoBalance.available)
          if(grandTotal >= 100){
            this.availableTokenToUse = availableToken >= 10 ? 10 : availableToken
          }
          const walletBalance = parseFloat(
            this.payOutDetail.walletAmount
          ).toFixed(2);
          this.cartListDetails.forEach((obj) => {
            this.cartId = obj._id;
            this.getID.push(this.cartId);
          });
          this.dropDownData = [
            {
              name: 'Proceed to Checkout',
              value: '',
            },
            {
              name: 'OZOW Payment',
              value: 'OZOW',
            },
            {
              name: 'PayGate Payment',
              value: 'PAYGATE',
            },
            {
              name: 'Yoco Payment',
              value: 'YOCO',
            },
            {
              name: `Wallet (R ${walletBalance})`,
              value: 'WALLET',
            },
          ];
          
          this.commonService.hideSpinner();
          this.getTotalProductPrice();
          
          // Show delete success toast after product is removed from UI
          if (showDeleteSuccessToast) {
            // Wait for Angular to update the UI with the refreshed cart list
            setTimeout(() => {
              this.commonService.successToast('Deleted Successfully');
            }, 300);
          }
        } else {
          this.cartListDetails = [];
          this.isLoading = false;
          this.commonService.hideSpinner();
          this.commonService.errorToast(res.responseMessage);
          this.getTotalProductPrice();
        }
      },
      (err) => {
        this.cartListDetails = [];
        this.isLoading = false;
        this.commonService.hideSpinner();
      }
    );
  }
  itemDeleteModal(id) {
    this.itemSelectedId = id;
    $('#itemDeleteModal').modal('show');
  }
  itemSelectedId: any;
  removeCartList() {
    let url = `user/removeItemFromCart?_id=${this.itemSelectedId}`;
    this.commonService.showSpinner();
    this.commonService.deleteApi(url, 1).subscribe((res: any) => {
      if (res.responseCode == 200) {
        this.commonService.hideSpinner();
        // Refresh cart list - toast will be shown in getuserCartList after UI is updated
        this.getuserCartList(true); // Pass true to show delete success toast after refresh
      } else {
        this.commonService.hideSpinner();
        this.commonService.errorToast(res.responseMessage);
      }
    });
  }
  updateCartValue(id, prizeSize, avlQty) {
    if (avlQty == 0) {
      return this.commonService.infoToast('Quantity can not be 0.');
    }
    let apiReqUrl = `user/updateCartItem?_id=${id}`;
    let apiReqData = {
      quantity: avlQty,
      priceSizeDetails: {
        value: prizeSize.value,
        price: Number(prizeSize.price),
        unit: prizeSize.unit,
        id: prizeSize.id,
      },
    };

    this.commonService.showSpinner();
    this.commonService.putApi(apiReqUrl, apiReqData, 1).subscribe(
      (res: any) => {
        if (res.responseCode == 200) {
          // this.cartListDetails = res.result;
          // this.qtyA = this.cartListDetails.quantity
          this.commonService.successToast(res.responseMessage);
          this.commonService.hideSpinner();
          this.getuserCartList();
        } else {
          this.commonService.hideSpinner();
          this.commonService.errorToast(res.responseMessage);
        }
      },
      (err) => {
        this.commonService.hideSpinner();
        return this.commonService.errorToast(err.responseMessage);
      }
    );
  }
  date: any = Date;

  getAddedDate(createdAt: string, days: number) {
    let date = new Date(createdAt).setDate(new Date(createdAt).getDate() + 7);
    return date;
  }

  // Calculate expected delivery date based on selected delivery mode
  getExpectedDeliveryDate(): string {
    if (!this.payOutDetail || !this.payOutDetail.deliveryMode) {
      return '';
    }

    const deliveryMode = this.payOutDetail.deliveryMode;
    const currentDate = new Date();

    switch (deliveryMode) {
      case 'SAMEDAY':
        return this.getNextDayOrSameDay(currentDate);
      case 'BUSINESSDAY':
        return this.getNextBusinessDayFromDate(currentDate);
      case 'SATURDAY':
        return this.getNextSaturdayFromDate(currentDate);
      case 'SUNDAY':
        return this.getSundayDate(currentDate);
      case 'STANDARD':
      default:
        // Standard delivery: typically 3-7 business days
        return this.getStandardDeliveryDate(currentDate);
    }
  }

  getNextDayOrSameDay(inputDate: Date): string {
    const currentDate = new Date();
    const currentHour = currentDate.getHours();

    // If it's before 5 PM, return the same day
    if (currentHour < 17) {
      return currentDate.toISOString().split('T')[0];
    } else {
      // If it's 5 PM or later, return the next day
      const nextDay = new Date(currentDate);
      nextDay.setDate(currentDate.getDate() + 1);
      return nextDay.toISOString().split('T')[0];
    }
  }

  getNextBusinessDayFromDate(inputDate: Date): string {
    const currentDate = new Date();
    const nextDay = new Date(currentDate);
    nextDay.setDate(currentDate.getDate() + 1);

    // Check if the next day is a weekend (Saturday or Sunday)
    if (nextDay.getDay() === 0) {
      // If it's Sunday, add 2 days to get to the next business day (Monday)
      nextDay.setDate(nextDay.getDate() + 2);
    } else if (nextDay.getDay() === 6) {
      // If it's Saturday, add 1 day to get to the next business day (Monday)
      nextDay.setDate(nextDay.getDate() + 1);
    }

    return nextDay.toISOString().split('T')[0];
  }

  getNextSaturdayFromDate(inputDate: Date): string {
    const currentDate = new Date();
    const currentDayOfWeek = currentDate.getDay();

    // Calculate the number of days until the next Saturday
    const daysUntilNextSaturday = 6 - currentDayOfWeek + 7;

    // Create a new Date object for the next Saturday
    const nextSaturday = new Date(currentDate);
    nextSaturday.setDate(currentDate.getDate() + daysUntilNextSaturday);

    return nextSaturday.toISOString().split('T')[0];
  }

  getSundayDate(inputDate: Date): string {
    const currentDate = new Date();
    const currentDayOfWeek = currentDate.getDay();

    // Calculate the number of days until the next Sunday
    const daysUntilNextSunday = 7 - currentDayOfWeek;

    // Create a new Date object for the next Sunday
    const nextSunday = new Date(currentDate);
    nextSunday.setDate(currentDate.getDate() + daysUntilNextSunday);

    return nextSunday.toISOString().split('T')[0];
  }

  getStandardDeliveryDate(inputDate: Date): string {
    // Standard delivery: typically 3-7 business days (use 5 business days as average)
    const currentDate = new Date();
    let businessDaysAdded = 0;
    let date = new Date(currentDate);

    while (businessDaysAdded < 5) {
      date.setDate(date.getDate() + 1);
      // Skip weekends (Saturday = 6, Sunday = 0)
      if (date.getDay() !== 0 && date.getDay() !== 6) {
        businessDaysAdded++;
      }
    }

    return date.toISOString().split('T')[0];
  }
  subtotal: any = 0;
  total: any = 0;
  sum: any = 0;
  vatValue = 0;
  sumToatal = 0;
  totalPayAmount = 0;
  getTotalProductPrice() {
    if (this.cartListDetails.length) {
      this.sum = 0;
      this.total = 0;
      this.vatValue = 0;
      this.subtotal = 0;
      this.sumToatal = 0;
      this.totalPayAmount = 0;
      this.cartListDetails.forEach((element) => {
        // this.subtotal = this.subtotal + element.totalMrp * element.enteredQuantity
        this.total = element.totalPrice * element.quantity;
        this.sum += this.total;
        this.subtotal = this.sum;
        this.vatValue = 15 / 100;
        this.sumToatal = this.vatValue * this.sum;
        this.totalPayAmount = this.sumToatal + this.sum - this.availableTokenToUse;
        // this.total = this.subtotal + this.shippingCharge
      });
    } else {
      this.sum = 0;
    }
    // this.commonService.totalItemsInShoppingBag.next(this.totalItems)
  }

  profileData: any = [];
  getProfile() {
    let url = `user/viewAddress?addressId=${this.idOfAddress}`;
    this.isProfileLoading = true;
    this.commonService.showSpinner();
    this.commonService.getApi(url, 1).subscribe(
      (res: any) => {
        if (res['responseCode'] == 200) {
          this.isProfileLoading = false;
          this.commonService.hideSpinner();
          this.profileData = res['result'];
          // this.commonService.cryptoBalance.next(this.profileData.cryptoBalance)
         
          this.address = `${this.profileData.addressLine1}, ${this.profileData.addressLine2}, ${this.profileData.city}, ${this.profileData.state}, ${this.profileData.country}, ${this.profileData.countryCode} ${this.profileData.mobileNumber}`;
        } else {
          this.isProfileLoading = false;
          this.commonService.hideSpinner();
          this.commonService.errorToast(res['responseMessage']);
        }
      },
      (err) => {
        this.isProfileLoading = false;
        this.commonService.hideSpinner();
        this.commonService.errorToast('Server error');
      }
    );
  }
  navigateToEdit(id) {
    this.router.navigate(['/edit-address-customer'], {
      queryParams: { id: id },
    });
  }
  buyOrderData: any;
  buyOrder(flag: Number) {
    let url = `order/buyProduct`;
    let data = {
      actualPrice: this.payOutDetail.totalAmount,
      orderPrice: this.payOutDetail.totalAmountWithVat,
      address: this.profileData._id,
      cartId: this.getID,
      deliveryFee: this.payOutDetail.deliveryFee,
      deliveryType: this.payOutDetail.deliveryMode,
      weight: this.cartListDetails[0].weight,
      volume: this.cartListDetails[0].volume,
      tokenUsed : 0
    };
    if(this.isCoinRedeem){
      data.orderPrice = this.payOutDetail.totalAmountWithVat - this.availableTokenToUse
      data.tokenUsed = this.availableTokenToUse
    }
    this.flag = false;
    // alert(flag)
    this.commonService.postApi(url, data, 1).subscribe(
      (res: any) => {
        if (res['responseCode'] == 200) {
          this.buyOrderData = res['result'];
          localStorage.setItem('paymentList', 'product');
          if (flag == 1) {
            this.ozhoPayment();
          } else if (flag == 2) {
            this.walletPayment();
          } else if (flag == 4) {
            this.yocoPayment();
          } else {
            this.paygatePayment();
          }
        } else {
          this.flag = true;
          this.commonService.errorToast(res['responseMessage']);
        }
      },
      (err) => {
        this.flag = true;
        this.commonService.errorToast('Server error');
      }
    );
  }
  OzhoUrl: any;
    ozhoPayment() {
      let url = `order/ozowCheckOut?orderId=${this.buyOrderData._id}`;
     let data = {
  webFailure: this.commonService.webSiteUrl + 'customer-payment-cancel',
  webError: this.commonService.webSiteUrl + 'customer-payment-error',
  webSuccess: this.commonService.webSiteUrl + 'customer-payment-success',
  testMode: false,
  trxFrom: 'WEB',
};

    this.commonService.showSpinner();
    this.commonService.postApi(url, data, 1).subscribe(
      (res: any) => {
        if (res['responseCode'] == 200) {
          this.commonService.hideSpinner();
          this.OzhoUrl = res.result;

          this.ozhoRedirect();
        } else {
          this.commonService.hideSpinner();
          this.commonService.errorToast(res['responseMessage']);
        }
      },
      (err) => {
        this.commonService.hideSpinner();
        this.commonService.errorToast('Server error');
      }
    );
  }
  walletPayment() {
    if (this.payOutDetail.walletAmount < this.payOutDetail.totalAmountWithVat) {
      this.flag = true;
      this.commonService.errorToast('Insufficient Balance');
      return;
    }

    let url = `order/checkOutWalletOrder?orderId=${this.buyOrderData._id}`;
    let data = {
      webFailure: this.commonService.webSiteUrl + 'customer-payment-cancel',
      webError: this.commonService.webSiteUrl + 'customer-payment-error',
      webSuccess: this.commonService.webSiteUrl + 'customer-payment-success',
      cancelUrl: this.commonService.ozhoBaseUrl,
      errorUrl: this.commonService.ozhoBaseUrl,
      SuccessUrl: this.commonService.ozhoBaseUrl,
      testMode: true,
      trxFrom: 'WEB',
    };
    this.commonService.showSpinner();
    this.commonService.postApi(url, data, 1).subscribe(
      (res: any) => {
        if (res['responseCode'] == 200) {
          this.commonService.hideSpinner();
          this.OzhoUrl = res.result;
          this.router.navigate(['/customer-payment-success']);
        } else {
          this.commonService.hideSpinner();
          this.commonService.errorToast(res['responseMessage']);
        }
      },
      (err) => {
        this.commonService.hideSpinner();
        this.commonService.errorToast('Server error');
      }
    );
  }
  htmlData: any;
  payfastPayment() {
    console.log('before');
    let url = `payment/checkoutPayfast?orderId=${this.buyOrderData._id}`;
    let data = {
      webFailure: this.commonService.webSiteUrl + 'customer-payment-cancel',
      webError: this.commonService.webSiteUrl + 'customer-payment-error',
      webSuccess: this.commonService.webSiteUrl + 'customer-payment-success',
      cancelUrl: this.commonService.ozhoBaseUrl,
      errorUrl: this.commonService.ozhoBaseUrl,
      SuccessUrl: this.commonService.ozhoBaseUrl,
      testMode: true,
      trxFrom: 'WEB',
    };
    this.commonService.showSpinner();
    this.commonService.postApi(url, data, true).subscribe(
      (res: any) => {
        console.log(res);
        console.log('asaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa');

        if (res['responseCode'] == 200) {
          this.commonService.hideSpinner();
          this.htmlData = this.sanatizer.bypassSecurityTrustHtml(
            res.result.file
          );
          console.log('after');
          console.log(res);
          // debugger;
          // this.ozhoRedirect()
        } else {
          this.commonService.hideSpinner();
          this.commonService.errorToast(res['responseMessage']);
        }
      },
      (err) => {
        console.log(err);
        this.commonService.hideSpinner();
        this.commonService.errorToast('Server error');
      }
    );
  }

  paygatePayment() {
  console.log('before');
  const url = `payment/checkoutPayGate?orderId=${this.buyOrderData._id}`;
  const data = {
    webFailure: this.commonService.webSiteUrl + 'customer-payment-cancel',
    webError: this.commonService.webSiteUrl + 'customer-payment-error',
    webSuccess: this.commonService.webSiteUrl + 'customer-payment-success',
    cancelUrl: this.commonService.ozhoBaseUrl,
    errorUrl: this.commonService.ozhoBaseUrl,
    SuccessUrl: this.commonService.ozhoBaseUrl,
    testMode: false,
    trxFrom: 'WEB',
  };
  this.commonService.showSpinner();
  this.commonService.postApi(url, data, true).subscribe(
    (res: any) => {
      console.log(res);
      if (res['responseCode'] == 200) {
        this.commonService.hideSpinner();
        this.htmlData = this.sanatizer.bypassSecurityTrustHtml(res.result.file);
        this.autoSubmitInjectedForm('paygate-form');
        console.log('after');
      } else {
        this.commonService.hideSpinner();
        this.commonService.errorToast(res['responseMessage']);
      }
    },
    (err) => {
      console.log(err);
      this.commonService.hideSpinner();
      this.commonService.errorToast('Server error');
    }
  );
}
  private autoSubmitInjectedForm(formId: string): void {
    // Allow the DOM to update before attempting to find the injected form
    setTimeout(() => {
      try {
        const formElement = document.getElementById(formId) as HTMLFormElement | null;
        if (formElement && typeof formElement.submit === 'function') {
          formElement.submit();
        }
      } catch (error) {
        console.error('Auto-submit failed:', error);
      }
    }, 0);
  }
  ozhoRedirect() {
    window.location.href = this.OzhoUrl;
  }
  yocoPayment() {
    console.log('Starting Yoco payment process');
    console.log('Order ID:', this.buyOrderData._id);
    this.flag = false; // Disable buttons during processing
    
    // Store payment method and order ID in localStorage so success page knows which order to update
    localStorage.setItem('paymentMethod', 'YOCO');
    localStorage.setItem('lastOrderId', this.buyOrderData._id);
    localStorage.setItem('orderTimestamp', new Date().toISOString());
    
    // Use the centralized payment service
    this.commonService.showSpinner();
    this.paymentService.processYocoPayment(this.buyOrderData._id).subscribe(
      (res: any) => {
        this.commonService.hideSpinner();
        const success = this.paymentService.handleYocoPaymentResponse(res);
        if (!success) {
          this.flag = true; // Re-enable buttons if payment failed
        }
      },
      (err) => {
        console.error('Yoco checkout error:', err);
        if (err.error && err.error.responseMessage) {
          console.error('Error details:', err.error.responseMessage);
        }
        this.commonService.hideSpinner();
        this.commonService.errorToast('Server error while processing payment. Please try again.');
        this.flag = true; // Re-enable buttons
      }
    );
  }
  paymentMethod: any;
  getPayamnetMethod(e) {
    this.paymentMethod = e;
  }
  onContinuue() {
    if (this.paymentMethod == 'pay-fast') {
      this.buyOrder(1);
    } else if (this.paymentMethod == 'wallet') {
      this.buyOrder(2);
    } else {
      this.buyOrder(3);
    }
  }
  openChoosePaymentModal() {
    // Reset selection when opening modal - user must select a payment method
    this.selectedPaymentMethod = '';
    $('#premiumPaymentModal').modal('show');
  }

  getDeliveryName(e) {
    let deliveryOption =
      e == 'SUNDAY'
        ? 'Sunday'
        : e == 'SAMEDAY'
        ? 'Sameday'
        : e == 'BUSINESSDAY'
        ? 'Next business day'
        : e == 'SATURDAY'
        ? 'Saturday'
        : 'Standard';

    return deliveryOption;
  }
  back() {
    this.commonService.backLocation();
  }
  
  // Get location array from product data (matching image)
  getLocationArray(locations: any): string[] {
    if (!locations) return [];
    if (Array.isArray(locations)) return locations;
    if (typeof locations === 'string') {
      // Handle comma-separated string
      return locations.split(',').map(loc => loc.trim()).filter(loc => loc);
    }
    return [];
  }
  
  // Calculate amount needed for free shipping (matching image)
  getFreeShippingAmount(): number {
    if (!this.payOutDetail || !this.payOutDetail.totalAmountWithVat) return 0;
    const freeShippingThreshold = 700; // R700 for free shipping
    const currentTotal = parseFloat(this.payOutDetail.totalAmountWithVat);
    const amountNeeded = freeShippingThreshold - currentTotal;
    return amountNeeded > 0 ? amountNeeded : 0;
  }
  
setSelectedPayment(method: string) {
  this.selectedPaymentMethod = method;
}

selectPayment(e) {
  if (e === 'OZOW') {
    this.buyOrder(1);
  } else if (e === 'WALLET') {
    this.buyOrder(2);
  } else if (e === 'YOCO') {
    localStorage.setItem('orderTimestamp', new Date().toISOString());
    localStorage.setItem('paymentMethod', 'YOCO');
    localStorage.setItem('from_yoco_payment', 'true');
    this.buyOrder(4);
  } else if (e === 'PAYGATE') {
    // PayGate card payment
    this.buyOrder(3);
  } else {
    // Fallback (treat as PayGate)
    this.buyOrder(3);
  }
}

getPaymentLogo(value: string): string {
  const logoMap: { [key: string]: string } = {
    // 'OZOW': 'assets/latest/Ozow.png',
    'OZOW': 'assets/latest/Ozow Logomark.png',
    'PAYGATE': 'assets/latest/paygate.png',
    'YOCO': 'assets/latest/yoco.png',
    'WALLET': 'assets/latest/wallet.png'
  };
  return logoMap[value] || 'assets/latest/paygate.png';
}

getPaymentName(name: string, value: string): string {
  // Remove "Payment" suffix and clean up the name
  if (value === 'WALLET') {
    // Extract wallet balance from format "Wallet (R XXX)"
    const match = name.match(/Wallet \(R ([\d.]+)\)/);
    if (match) {
      return `Wallet (R ${match[1]})`;
    }
    return 'Wallet';
  }
  return name.replace(' Payment', '').trim();
}

getPaymentDescription(value: string): string {
  const descriptions: { [key: string]: string } = {
    'PAYGATE': 'Secure Payment Processing',
    'OZOW': 'Instant Bank Transfer',
    'YOCO': 'Card Payment Processing',
    'WALLET': 'Use Your Wallet Balance'
  };
  return descriptions[value] || 'Secure Payment Processing';
}

getPaymentSecurityFeatures(value: string): string[] {
  const features: { [key: string]: string[] } = {
    'PAYGATE': ['256-bit SSL', 'PCI DSS', '3D Secure'],
    'OZOW': ['Bank-level Security', 'PCI DSS', 'Real-time Verification'],
    'YOCO': ['256-bit SSL', 'PCI DSS', '3D Secure'],
    'WALLET': ['Secure Wallet', 'Encrypted Balance', 'Instant Transfer']
  };
  return features[value] || ['256-bit SSL', 'PCI DSS', '3D Secure'];
}

getPaymentCardTypes(value: string): string[] {
  const cardTypes: { [key: string]: string[] } = {
    'PAYGATE': ['VISA', 'MC', 'AMEX'],
    'OZOW': ['VISA', 'MC'],
    'YOCO': ['VISA', 'MC', 'AMEX'],
    'WALLET': []
  };
  return cardTypes[value] || ['VISA', 'MC', 'AMEX'];
}

isPaymentRecommended(value: string): boolean {
  return value === 'PAYGATE';
}
}
